import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkuEnum } from '@/types/translations/SkuEnum';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import clsx from 'clsx';
import { useRef } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export default function SkuQuestions() {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  const keys = useRef(
    Array.from({ length: 6 }, (_, i) => i + 1).map(i => [`faqs.faq${i}_q`, `faqs.faq${i}_a`])
  );

  return keys.current.map(([questionKey, answerKey]) => (
    <Disclosure key={`${questionKey}-${answerKey}`}>
      {({ open }) => (
        <>
          <DisclosureButton
            className={clsx(
              `tw-flex tw-w-full tw-items-center tw-justify-between tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-[#5F6D7E66] tw-bg-transparent tw-py-3 tw-text-lg tw-font-medium tw-text-text tw-transition tw-duration-300 tw-ease-in-out hover:tw-text-main-shades-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-main-shades-300 active:tw-opacity-80 max-nine:tw-text-left max-nine:!tw-text-base max-nine:tw-font-medium max-nine:tw-text-text`,
              open && 'tw-bg-main-shades-300 tw-bg-opacity-50 tw-text-main-shades-900'
            )}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: translate(SkuEnum[questionKey as SkuEnum]),
              }}
            />
            {open ? <FaChevronUp /> : <FaChevronDown />}
          </DisclosureButton>
          <DisclosurePanel
            className="tw-origin-top tw-p-4 tw-pl-2 tw-text-sm tw-leading-normal tw-text-black tw-transition tw-duration-200 tw-ease-out data-[closed]:tw--translate-y-6 data-[closed]:tw-opacity-0"
            transition
          >
            <div
              dangerouslySetInnerHTML={{
                __html: translate(SkuEnum[answerKey as SkuEnum]),
              }}
            />
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  ));
}
